import React, { useState, useEffect, useRef } from "react";
import './Money.css'
import Select from 'react-select'
import sendicon from './../../../../images/sendmoneyicon.png'
import receiveicon from './../../../../images/receivemoneyicon.png'
import receivepaymenticon from './../../../../images/receivepaymenticon.png'
import sendpaymenticon from './../../../../images/sendpaymenticon.png'
import banktransfericon from './../../../../images/banktransfericon.png'
import paymentinfoicon from './../../../../images/paymentinfobtn.png'
import walletgraph from './../../../../images/walletbars.png'
import walletcomingsoon from './../../../../images/walletcomingsoon.png'
import moreoptionsbtn from './../../../../images/moreoptionbtn.png'
import Royalties from "./Royalties";
import Statements from "./Statements";
import Wallet from "./Wallet";
import { Trans, useTranslation } from 'react-i18next'
import i18next from "i18next"
import Cookies from 'universal-cookie';
import { Route, Routes, Redirect, Navigate } from 'react-router-dom'
import { useLocation, useNavigate } from "react-router-dom";
import { City } from "country-state-city";
import ReactModal from 'react-modal';
import crossicon from './../../../../images/crossicon.png'
import { useJwt, decodeToken } from "react-jwt";
import { logtoWix } from "../../../Helpers/LogToWix";


function Money({ nav, hidedashboard }) {

    const { t, i18n } = useTranslation();
    const [option, setOption] = useState(1)
    const cookies = new Cookies(null, { path: '/' });
    const [walletEmpty, setWalletEmpty] = useState(false)
    const navigate = useNavigate();
    const location = useLocation();
    const [successfulRequest, setSuccessfulRequest] = useState(false)
    const [email, setEmail] = useState("")
    const [country, setCountry] = useState("")
    const [name, setName] = useState("")
    const [phno, setPhNo] = useState("")
    const [bankname, setBankName] = useState("")
    const [bankacc, setBankAcc] = useState("")
    const [iban, setIban] = useState("")
    const [routingNo, setRoutingNo] = useState("")
    const [address1, setAddress1] = useState("")
    const [address2, setAddress2] = useState("")
    const [Addresscity, setAddressCity] = useState("")
    const [zipcode, setZipCode] = useState("")
    const [addState, setAddState] = useState("")
    const [addCountry, setAddCountry] = useState("")
    const [typeOfRequest, setTypeOfRequest] = useState("")
    const [nervePlan, setNervePlan] = useState("")
    const [subject, setSubject] = useState("")
    const [desc, setDesc] = useState("")
    const [moneyPopUp, setMoneyPopUp] = useState(true)
    const [sucessPopUp, setSucessPopUp] = useState(false)
    const [files, setFiles] = useState([])
    const [dragActive, setDragActive] = useState(false)
    const inputRef = useRef(null)
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    })
    const hasLogged = useRef(false);

    const toroptions = [{ value: 'Account', label: 'Account' },
    { value: 'App', label: 'App' },
    { value: 'Distribution', label: 'Distribution' },
    { value: 'Exclusive', label: 'Exclusive' },
    { value: 'Payment', label: 'Payment' },
    { value: 'Promotion', label: 'Promotion' },
    { value: 'Referrals', label: 'Referrals' },
    { value: 'Socials', label: 'Socials' },
    { value: 'Split Payment', label: 'Split Payment' },
    { value: 'Terms of Use', label: 'Terms of Use' },
    { value: 'Video', label: 'Video' },
    { value: 'Mastering', label: 'Mastering' }]

    const npooptions = [{ value: 'N3RVOUS (Free)', label: 'N3RVOUS (Free)' },
    { value: 'N3RVE', label: 'N3RVE' },
    { value: 'N3RVE Premier', label: 'N3RVE Premier' },
    { value: 'N3XUS', label: 'N3XUS' }]

    const changetorHandler = value => {
        setTypeOfRequest(value)
    }

    const changenpoHandler = value => {
        setNervePlan(value)
    }

    function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    const handleResize = () => {
        console.log(window.innerWidth)
        setDimensions({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    }

    useEffect(() => {
        topFunction()
        hidedashboard(true)
        nav("Wallet")
        // if(cookies.get("artistname").length!==0){
        //     setWalletEmpty(false)
        // }

        if (!hasLogged.current) {
            if (cookies.get('token') !== undefined) {
                if (decodeToken(cookies.get('token')) !== null) {
                    logtoWix(decodeToken(cookies.get('token')).email, "pageview", "Artist Dashboard Money Page", { "desc": "User opened the artist dashboard money page" })
                    hasLogged.current = true;
                } else {
                    logtoWix("anonymous user", "pageview", "Artist Dashboard Money Page", { "desc": "User opened the artist dashboard money page" })
                    hasLogged.current = true;
                }
            } else {
                logtoWix("anonymous user", "pageview", "Artist Dashboard Money Page", { "desc": "User opened the artist dashboard money page" })
                hasLogged.current = true;
            }
        }

    }, [])

    const colourStyles = {
        container: base => ({
            ...base,
            flex: 1
        }),
        control: styles => ({
            ...styles, borderColor: '#636468',
            backgroundColor: 'rgba(0,0,0,16%)',
            maxWidth: '35.18em',
            width: '100%',
            height: '3em',
            borderRadius: '8px',
            color: 'rgba(255, 255, 255, 1)',
            marginTop: '1.2em'
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                backgroundColor: '#18191F',
                color: 'rgba(255, 255, 255, 1)',
                cursor: isDisabled ? 'not-allowed' : 'default',
                marginTop: '-0.3em',
                marginBottom: '-0.3em'
            };
        },
        input: (styles) => ({
            ...styles,
            FontFamily: 'ClashGrotesk-Variable,sans-serif',
            FontSize: '1rem',
            FontWeight: 'medium',
            LineHeight: '150%',
            LetterSpacing: '0%',
            color: 'rgba(255, 255, 255, 1)'
        }),
        singleValue: (styles) => ({
            ...styles,
            color: 'rgba(255, 255, 255, 1)',
            FontFamily: 'ClashGrotesk-Variable,sans-serif',
            FontSize: '1rem',
            FontWeight: 'medium',
            LineHeight: '150%',
            LetterSpacing: '0%'
        })
    };

    useEffect(() => {
        if (location.pathname === "/Dashboard/money/" || location.pathname === "/Dashboard/money") {
            setOption(1)
        }
        if (location.pathname === "/Dashboard/money/wallet") {
            setOption(2)
        }

        if (location.pathname === "/Dashboard/money/statements") {
            setOption(3)
        }
    }, [location.pathname])

    function closeModal() {
        setMoneyPopUp(false);
    }

    function closeSucessModal() {
        setSucessPopUp(false);
    }


    return (
        <div style={{ minHeight: '100vh', height: 'auto', paddingBottom: '5em' }} className={walletEmpty ? "WalletEmptyContainer" : "WalletFullContainer"}>
            {
                walletEmpty &&
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <img src={walletcomingsoon} style={{ width: '20.91em', aspectRatio: '0.72', marginTop: '5em' }} />
                    <div className="NoAnalticsH1" style={{ marginTop: '1em' }}>Wallet is Coming Soon...</div>
                    <div className="NoAnalticsH2">The Wallet  is on its way! Soon, you'll be able to receive your royalties directly on N3RVE. Stay tuned for this exciting update!</div>


                    {/* {
                                dimensions.width < 820 &&
                                        <div style={{position:'relative',minHeight:'100vh',height:'auto'}}>
                                        {
                                        !successfulRequest &&
                                            <div>
                                                <div style={{
                                                    width:'100%',
                                                    display:'flex',
                                                    flexDirection:'column',
                                                    alignItems:'center',
                                                    paddingBottom:'15.5em',
                                                    paddingTop:'2.56em'
                                                }}>
                                                    <div style={{
                                                    width:'100%',
                                                    display:'flex',
                                                    flexDirection:'column',
                                                    alignItems:'center',
                                                    
                                                }}>
                                                    <div style={{
                                                        display:'flex',
                                                        flexDirection:'column',
                                                        alignItems:'flex-start',
                                                        width:'100%',
                                                        paddingTop:'2.5em',
                                                    
                                                    }}>

                                                            <div className="SubmitHeader">
                                                                Enter Bank Details
                                                            </div>

                                                            <div className="SubmitInputHeader">
                                                                Bank Country
                                                            </div>

                                                            <input
                                                                value={country}
                                                                onChange={e =>{setCountry(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter Country"
                                                                style={{marginBottom:'0em'}}
                                                                />

                                                            <div className="SubmitInputHeader">
                                                                Name On Account
                                                            </div>

                                                            <input
                                                                value={name}
                                                                onChange={e =>{setName(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter Name on Account"
                                                                style={{marginBottom:'0em'}}
                                                                />

                                                            <div className="SubmitInputHeader">
                                                                Phone Number
                                                            </div>

                                                            <input
                                                                value={phno}
                                                                onChange={e =>{setPhNo(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter Phone Number"
                                                                style={{marginBottom:'0em'}}
                                                                />

                                                            <div className="SubmitInputHeader">
                                                                Bank Name
                                                            </div>

                                                            <input
                                                                value={bankname}
                                                                onChange={e =>{setBankName(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter Name of Bank"
                                                                style={{marginBottom:'0em'}}
                                                                />

                                                             <div className="SubmitInputHeader">
                                                                Account Number
                                                            </div>

                                                            <input
                                                                value={bankacc}
                                                                onChange={e =>{setBankAcc(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter Account Number"
                                                                style={{marginBottom:'0em'}}
                                                                />

                                                            <div className="SubmitInputHeader">
                                                                IBAN/SWIFT
                                                            </div>

                                                            <input
                                                                value={iban}
                                                                onChange={e =>{setIban(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter IBAN/SWIFT Code"
                                                                style={{marginBottom:'0em'}}
                                                                />

                                                            <div className="SubmitInputHeader">
                                                                Routing Number
                                                            </div>

                                                            <input
                                                                value={routingNo}
                                                                onChange={e =>{setRoutingNo(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter Routing Number"
                                                                style={{marginBottom:'0em'}}
                                                                />

                                                            <div className="SubmitInputHeader">
                                                                Address Line 1
                                                            </div>

                                                            <input
                                                                value={address1}
                                                                onChange={e =>{setAddress1(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter Address Line 1"
                                                                style={{marginBottom:'0em'}}
                                                                />
                                                            
                                                            <div className="SubmitInputHeader">
                                                                Address Line 2
                                                            </div>

                                                            <input
                                                                value={address2}
                                                                onChange={e =>{setAddress2(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter Address Line 2"
                                                                style={{marginBottom:'0em'}}
                                                                />

                                                            <div className="SubmitInputHeader">
                                                               Address City
                                                            </div>

                                                            <input
                                                                value={Addresscity}
                                                                onChange={e =>{setAddressCity(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter City"
                                                                style={{marginBottom:'0em'}}
                                                                />

                                                            <div className="SubmitInputHeader">
                                                               Zipcode
                                                            </div>

                                                            <input
                                                                value={zipcode}
                                                                onChange={e =>{setZipCode(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter Zipcode"
                                                                style={{marginBottom:'0em'}}
                                                                />

                                                            <div className="SubmitInputHeader">
                                                               Address State
                                                            </div>

                                                            <input
                                                                value={addState}
                                                                onChange={e =>{setAddState(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter State"
                                                                style={{marginBottom:'0em'}}
                                                                />

                                                            <div className="SubmitInputHeader">
                                                              Address Country
                                                            </div>

                                                            <input
                                                                value={addCountry}
                                                                onChange={e =>{setAddCountry(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter Country"
                                                                style={{marginBottom:'0em'}}
                                                                />

                                                           
                                                            <div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',width:'34.187em'}}>
                                                            <div className="SubmitRequestBtn" onClick={()=>{setSuccessfulRequest(true);topFunction()}} style={{alignSelf:'center',marginLeft:'0em',marginRight:'0em'}}>
                                                                SUBMIT
                                                                <div className="PostLoginBtnOverlay" style={{borderRadius:'999px',left:'0em'}}/>
                                                            </div>
                                                            </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                        }

                                        {
                                            successfulRequest &&
                                            <div style={{display:'flex',flexDirection:'column',alignItems:'center',paddingBottom:'20em'}}>
                                                <div className="successHeader">
                                                Thank you for entering your bank details!
                                                </div>

                                                <div className="successInfo">
                                                Bank Details Entered Successfully<br/>
                                                </div>

                                                <div className="SubmitRequestBtn" style={{alignSelf:'center'}} onClick={()=>{setSuccessfulRequest(false);navigate("/Dashboard")}}>
                                                    Back to Main
                                                    <div className="PostLoginBtnOverlay" style={{borderRadius:'999px',left:'0em'}}/>
                                                </div>

                                            </div>
                                        }



                                        </div>
                                        }

                            {
                                dimensions.width >= 820 &&
                                        <div style={{position:'relative',minHeight:'100vh',height:'auto'}}>
                                        {
                                        !successfulRequest &&
                                            <div>
                                                <div style={{
                                                    width:'100%',
                                                    display:'flex',
                                                    flexDirection:'column',
                                                    alignItems:'center',
                                                    paddingBottom:'15.5em',
                                                    paddingTop:'2.56em'
                                                }}>
                                                    <div style={{
                                                        display:'flex',
                                                        flexDirection:'column',
                                                        alignItems:'flex-start',
                                                        width:'100%',
                                                        paddingTop:'2.5em',
                                                    
                                                    }}>

                                                            <div className="SubmitHeader">
                                                                Enter Bank Details
                                                            </div>

                                                            <div className="SubmitInputHeader">
                                                                Bank Country
                                                            </div>

                                                            <input
                                                                value={country}
                                                                onChange={e =>{setCountry(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter Country"
                                                                style={{marginBottom:'0em'}}
                                                                />

                                                            <div className="SubmitInputHeader">
                                                                Name On Account
                                                            </div>

                                                            <input
                                                                value={name}
                                                                onChange={e =>{setName(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter Name on Account"
                                                                style={{marginBottom:'0em'}}
                                                                />

                                                            <div className="SubmitInputHeader">
                                                                Phone Number
                                                            </div>

                                                            <input
                                                                value={phno}
                                                                onChange={e =>{setPhNo(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter Phone Number"
                                                                style={{marginBottom:'0em'}}
                                                                />

                                                            <div className="SubmitInputHeader">
                                                                Bank Name
                                                            </div>

                                                            <input
                                                                value={bankname}
                                                                onChange={e =>{setBankName(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter Name of Bank"
                                                                style={{marginBottom:'0em'}}
                                                                />

                                                             <div className="SubmitInputHeader">
                                                                Account Number
                                                            </div>

                                                            <input
                                                                value={bankacc}
                                                                onChange={e =>{setBankAcc(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter Account Number"
                                                                style={{marginBottom:'0em'}}
                                                                />

                                                            <div className="SubmitInputHeader">
                                                                IBAN/SWIFT
                                                            </div>

                                                            <input
                                                                value={iban}
                                                                onChange={e =>{setIban(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter IBAN/SWIFT Code"
                                                                style={{marginBottom:'0em'}}
                                                                />
                                                            
                                                            <div className="SubmitInputHeader">
                                                                Routing Number
                                                            </div>

                                                            <input
                                                                value={routingNo}
                                                                onChange={e =>{setRoutingNo(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter Routing Number"
                                                                style={{marginBottom:'0em'}}
                                                                />

                                                            <div className="SubmitInputHeader">
                                                                Address Line 1
                                                            </div>

                                                            <input
                                                                value={address1}
                                                                onChange={e =>{setAddress1(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter Address Line 1"
                                                                style={{marginBottom:'0em'}}
                                                                />
                                                            
                                                            <div className="SubmitInputHeader">
                                                                Address Line 2
                                                            </div>

                                                            <input
                                                                value={address2}
                                                                onChange={e =>{setAddress2(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter Address Line 2"
                                                                style={{marginBottom:'0em'}}
                                                                />

                                                            <div className="SubmitInputHeader">
                                                               Address City
                                                            </div>

                                                            <input
                                                                value={Addresscity}
                                                                onChange={e =>{setAddressCity(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter City"
                                                                style={{marginBottom:'0em'}}
                                                                />

                                                            <div className="SubmitInputHeader">
                                                               Zipcode
                                                            </div>

                                                            <input
                                                                value={zipcode}
                                                                onChange={e =>{setZipCode(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter Zipcode"
                                                                style={{marginBottom:'0em'}}
                                                                />

                                                            <div className="SubmitInputHeader">
                                                               Address State
                                                            </div>

                                                            <input
                                                                value={addState}
                                                                onChange={e =>{setAddState(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter State"
                                                                style={{marginBottom:'0em'}}
                                                                />

                                                            <div className="SubmitInputHeader">
                                                              Address Country
                                                            </div>

                                                            <input
                                                                value={addCountry}
                                                                onChange={e =>{setAddCountry(e.target.value);}} 
                                                                className='InputFieldbk'
                                                                type='text'
                                                                placeholder="Enter Country"
                                                                style={{marginBottom:'0em'}}
                                                                />

                                                           
                                                            <div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',width:'34.187em'}}>
                                                            <div className="SubmitRequestBtn" onClick={()=>{setSuccessfulRequest(true);topFunction()}} style={{alignSelf:'center',marginLeft:'0em',marginRight:'0em'}}>
                                                                SUBMIT
                                                                <div className="PostLoginBtnOverlay" style={{borderRadius:'999px',left:'0em'}}/>
                                                            </div>
                                                            </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                    {
                        successfulRequest &&
                        <div style={{display:'flex',flexDirection:'column',alignItems:'center',paddingBottom:'20em'}}>
                             <div className="successHeader">
                                Thank you for entering your bank details!
                            </div>

                            <div className="successInfo">
                                    Bank Details entered Successfully
                            </div>

                            <div className="SubmitRequestBtn" style={{alignSelf:'center'}} onClick={()=>{setSuccessfulRequest(false);navigate("/Dashboard")}}>
                                Back to Main
                                <div className="PostLoginBtnOverlay" style={{borderRadius:'999px',left:'0em'}}/>
                            </div>

                        </div>
                    }



                    </div>
                    }   */}
                </div>
            }

            {
                !walletEmpty &&
                <div className="WalletContainer" style={{ paddingBottom: '5em' }}>
                    <ReactModal
                        isOpen={moneyPopUp}
                        overlayClassName="Overlay"
                        contentLabel="Example Modal"
                        onRequestClose={closeModal} // closes the modal when the user presses the escape key
                        shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
                        style={{
                            content: {
                                width: '42.125em',
                                margin: 'auto',
                                backgroundImage: 'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                borderRadius: '8px',
                                border: '0.5px solid rgba(255,255,255,25%)',
                                scrollbarWidth: 'none'
                            }
                        }}
                    >

                        <img src={crossicon} style={{ height: '1.5em', width: '1.5em', position: 'sticky', right: '0em', top: '-0.5em', marginTop: '-5.5em', cursor: 'pointer', alignSelf: 'flex-end', zIndex: '4' }} onClick={() => setMoneyPopUp(false)} />
                        <div style={{ position: 'relative', minHeight: '100vh', height: 'auto' }}>

                            <div>
                                <div style={{
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    paddingBottom: '2.5em'
                                }}>
                                    <div style={{
                                        width: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',

                                    }}>
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'flex-start',
                                            width: '100%',
                                            paddingTop: '2.5em',

                                        }}>

                                            <div className="SubmitHeader">
                                                Enter Bank Details
                                            </div>

                                            <div className="SubmitInputHeader">
                                                Bank Country
                                            </div>

                                            <input
                                                value={country}
                                                onChange={e => { setCountry(e.target.value); }}
                                                className='InputFieldbk'
                                                type='text'
                                                placeholder="Enter Country"
                                                style={{ marginBottom: '0em' }}
                                            />

                                            <div className="SubmitInputHeader">
                                                Name On Account
                                            </div>

                                            <input
                                                value={name}
                                                onChange={e => { setName(e.target.value); }}
                                                className='InputFieldbk'
                                                type='text'
                                                placeholder="Enter Name on Account"
                                                style={{ marginBottom: '0em' }}
                                            />

                                            <div className="SubmitInputHeader">
                                                Phone Number
                                            </div>

                                            <input
                                                value={phno}
                                                onChange={e => { setPhNo(e.target.value); }}
                                                className='InputFieldbk'
                                                type='text'
                                                placeholder="Enter Phone Number"
                                                style={{ marginBottom: '0em' }}
                                            />

                                            <div className="SubmitInputHeader">
                                                Bank Name
                                            </div>

                                            <input
                                                value={bankname}
                                                onChange={e => { setBankName(e.target.value); }}
                                                className='InputFieldbk'
                                                type='text'
                                                placeholder="Enter Name of Bank"
                                                style={{ marginBottom: '0em' }}
                                            />

                                            <div className="SubmitInputHeader">
                                                Account Number
                                            </div>

                                            <input
                                                value={bankacc}
                                                onChange={e => { setBankAcc(e.target.value); }}
                                                className='InputFieldbk'
                                                type='text'
                                                placeholder="Enter Account Number"
                                                style={{ marginBottom: '0em' }}
                                            />

                                            <div className="SubmitInputHeader">
                                                IBAN/SWIFT
                                            </div>

                                            <input
                                                value={iban}
                                                onChange={e => { setIban(e.target.value); }}
                                                className='InputFieldbk'
                                                type='text'
                                                placeholder="Enter IBAN/SWIFT Code"
                                                style={{ marginBottom: '0em' }}
                                            />

                                            <div className="SubmitInputHeader">
                                                Routing Number
                                            </div>

                                            <input
                                                value={routingNo}
                                                onChange={e => { setRoutingNo(e.target.value); }}
                                                className='InputFieldbk'
                                                type='text'
                                                placeholder="Enter Routing Number"
                                                style={{ marginBottom: '0em' }}
                                            />

                                            <div className="SubmitInputHeader">
                                                Address Line 1
                                            </div>

                                            <input
                                                value={address1}
                                                onChange={e => { setAddress1(e.target.value); }}
                                                className='InputFieldbk'
                                                type='text'
                                                placeholder="Enter Address Line 1"
                                                style={{ marginBottom: '0em' }}
                                            />

                                            <div className="SubmitInputHeader">
                                                Address Line 2
                                            </div>

                                            <input
                                                value={address2}
                                                onChange={e => { setAddress2(e.target.value); }}
                                                className='InputFieldbk'
                                                type='text'
                                                placeholder="Enter Address Line 2"
                                                style={{ marginBottom: '0em' }}
                                            />

                                            <div className="SubmitInputHeader">
                                                Address City
                                            </div>

                                            <input
                                                value={Addresscity}
                                                onChange={e => { setAddressCity(e.target.value); }}
                                                className='InputFieldbk'
                                                type='text'
                                                placeholder="Enter City"
                                                style={{ marginBottom: '0em' }}
                                            />

                                            <div className="SubmitInputHeader">
                                                Zipcode
                                            </div>

                                            <input
                                                value={zipcode}
                                                onChange={e => { setZipCode(e.target.value); }}
                                                className='InputFieldbk'
                                                type='text'
                                                placeholder="Enter Zipcode"
                                                style={{ marginBottom: '0em' }}
                                            />

                                            <div className="SubmitInputHeader">
                                                Address State
                                            </div>

                                            <input
                                                value={addState}
                                                onChange={e => { setAddState(e.target.value); }}
                                                className='InputFieldbk'
                                                type='text'
                                                placeholder="Enter State"
                                                style={{ marginBottom: '0em' }}
                                            />

                                            <div className="SubmitInputHeader">
                                                Address Country
                                            </div>

                                            <input
                                                value={addCountry}
                                                onChange={e => { setAddCountry(e.target.value); }}
                                                className='InputFieldbk'
                                                type='text'
                                                placeholder="Enter Country"
                                                style={{ marginBottom: '0em' }}
                                            />


                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '34.187em' }}>
                                                <div className="SubmitRequestBtn" onClick={() => { setMoneyPopUp(false); setSucessPopUp(true); topFunction() }} style={{ alignSelf: 'center', marginLeft: '0em', marginRight: '0em' }}>
                                                    SUBMIT
                                                    <div className="PostLoginBtnOverlay" style={{ borderRadius: '999px', left: '0em' }} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>







                        </div>
                    </ReactModal>

                    <ReactModal
                        isOpen={sucessPopUp}
                        overlayClassName="Overlay"
                        contentLabel="Example Modal"
                        onRequestClose={closeSucessModal} // closes the modal when the user presses the escape key
                        shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
                        style={{
                            content: {
                                width: '35.125em',
                                margin: 'auto',
                                backgroundImage: 'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                borderRadius: '8px',
                                border: '0.5px solid rgba(255,255,255,25%)',
                                scrollbarWidth: 'none',
                                height: '20em'
                            }
                        }}
                    >
                        <img src={crossicon} style={{ height: '1.5em', width: '1.5em', position: 'sticky', right: '0em', top: '-0.5em', marginTop: '-20.5em', cursor: 'pointer', alignSelf: 'flex-end', zIndex: '4' }} onClick={() => setSucessPopUp(false)} />
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingBottom: '2em' }}>
                            <div className="successHeader">
                                Thank you for entering your bank details!
                            </div>

                            <div className="successInfo">
                                Bank Details Entered Successfully<br />
                            </div>

                            <div className="SubmitRequestBtn" style={{ alignSelf: 'center' }} onClick={() => { setSucessPopUp(false) }}>
                                Back to Wallet
                                <div className="PostLoginBtnOverlay" style={{ borderRadius: '999px', left: '0em' }} />
                            </div>

                        </div>
                    </ReactModal>
                    <div className="WalletHeaderTxt">
                        MONEY
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'row', borderBottom: '1px #595959 solid', marginLeft: '0em', width: '95.28%', marginTop: '2em' }}>
                        {
                            option !== 1 &&
                            <div>
                                <div className="MoneyDrawerHeading" onClick={() => { setOption(1); navigate('/Dashboard/money/') }} style={{ cursor: 'pointer' }}>ROYALTIES</div>
                            </div>
                        }

                        {
                            option === 1 &&
                            <div>
                                <div className="MoneyDrawerHeadingSelected">ROYALTIES</div>
                                <div style={{ backgroundColor: '#FF6694', height: '1px' }} />
                            </div>
                        }

                        {
                            option !== 2 &&
                            <div>
                                <div className="MoneyDrawerHeading" onClick={() => { setOption(2); navigate('/Dashboard/money/wallet') }} style={{ cursor: 'pointer' }}>WALLET</div>
                            </div>
                        }

                        {
                            option === 2 &&
                            <div>
                                <div className="MoneyDrawerHeadingSelected">WALLET</div>
                                <div style={{ backgroundColor: '#FF6694', height: '1px' }} />
                            </div>
                        }

                        {
                            option !== 3 &&
                            <div>
                                <div className="MoneyDrawerHeading" onClick={() => { setOption(3); navigate('/Dashboard/money/statements') }} style={{ cursor: 'pointer' }}>STATEMENTS</div>
                            </div>
                        }

                        {
                            option === 3 &&
                            <div>
                                <div className="MoneyDrawerHeadingSelected">STATEMENTS</div>
                                <div style={{ backgroundColor: '#FF6694', height: '1px' }} />
                            </div>
                        }



                    </div>

                    <div style={{ width: '95.28%', marginTop: '1.5em' }}>
                        {
                            option === 1 &&
                            <Routes>
                                <Route exact path="/" element={<Royalties nav={nav} />} />
                            </Routes>
                        }

                        {
                            option === 2 &&
                            <Routes>
                                <Route exact path="/wallet" element={<Wallet />} />
                            </Routes>
                        }

                        {
                            option === 3 &&
                            <Routes>
                                <Route exact path="/statements" element={<Statements />} />
                            </Routes>
                        }
                    </div>

                    {/* <div style={{display:'flex',flexDirection:'row',width:'95%',marginTop:'1.5em'}}>
                    <div className="WalletContainerLeft">
                        <div className="BalanceTxt">
                        {t('Balance')} 
                        </div>
    
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center'}}>
    
                            {
                                cookies.get('lang') === 'en' &&
                                <div style={{display:'flex',flexDirection:'row',alignItems:'baseline'}} >
                                    <div className="AmountPrefix">
                                        $1,682
                                    </div>
                                    <div className="AmountSuffix">
                                        .55 USD
                                    </div>
                                </div>
                            }
    
                            {
                                cookies.get('lang') === 'jp' &&
                                <div style={{display:'flex',flexDirection:'row',alignItems:'baseline'}} >
                                    <div className="AmountPrefix">
                                        68500円
                                    </div>
                                </div>
                            }
                            
    
                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <div className="SendReceiveContainer">
                                    <img src={sendicon} className="SendIcon"/>
                                    <div className="SendTxt">
                                    {t('Send')} 
                                    </div>
                                </div>
    
                                <div className="SendReceiveContainer">
                                    <img src={receiveicon} className="SendIcon"/>
                                    <div className="SendTxt">
                                    {t('Receive')} 
                                    </div>
                                </div>
    
                            
                                <img src={moreoptionsbtn} style={{width:'1.25em',height:'1.25em',cursor:'pointer'}}/>
                            </div>
    
                        </div>
                    </div>
    
                    <div className="WalletContainerRight">
                           <div>
                                <div className="BalanceTxt">
                                {t('Monthlyroyalty')} 
                                </div>
                                {
                                    cookies.get('lang') === 'en' &&
                                    <div style={{display:'flex',flexDirection:'row',alignItems:'baseline'}}>
                                        <div className="AmountPrefix">
                                            $483
                                        </div>
    
                                        <div className="AmountSuffix">
                                            .00 USD
                                        </div>
                                    </div>
                                }
    
                                {
                                    cookies.get('lang') === 'jp' &&
                                    <div style={{display:'flex',flexDirection:'row',alignItems:'baseline'}}>
                                        <div className="AmountPrefix">
                                        20300円
                                        </div>
                                    </div>
                                }
    
                           </div>
    
                           <img src={walletgraph} style={{width:'10.375em',height:'4.81em',marginLeft:'1.375em'}}/>
                    </div>
                </div> */}


                    {/* <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center',width:'95%'}}>
                        <div className="BalanceTxt" style={{marginTop:'1em'}}>
                        {t('Latesttrans')} 
                        </div>
                        <img src={moreoptionsbtn} style={{width:'1.25em',height:'1.25em',cursor:'pointer'}}/>
                    </div> */}

                    {/* <div className="TransactionListItem">
                        <div style={{display:'flex',flexDirection:'row',width:'30%'}}>
                            <img src={receivepaymenticon} style={{width:'2em',height:'2em',marginRight:'1em'}}/>
    
                            <div style={{display:'flex',flexDirection:'column',marginTop:'-0.3em'}}>
                                <div className="TransactionName">
                                {t('Royaltypayment')}
                                </div>
                                <div className="TransactionDate">
                                {t('Yesterday')}
                                </div>
                            </div>
    
                        </div>
    
                        <div className="TransactionType">
                        {t('Received')}
                        </div>
    
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'20%',alignContent:'flex-end',justifyContent:'flex-end'}}>
                        {
                                    cookies.get('lang') === 'en' &&
                            <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                                $132.90
                            </div>
                        }
                        {
                                    cookies.get('lang') === 'jp' &&
                            <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                                19378円
                            </div>
                        }
    
                            <img src={paymentinfoicon} style={{width:'0.6em',height:'0.85em',marginLeft:'1.7em'}}/>
    
                        </div>
    
                    </div> */}

                    {/* <div className="TransactionListItem">
                        <div style={{display:'flex',flexDirection:'row',width:'30%'}}>
                            <img src={banktransfericon} style={{width:'2em',height:'2em',marginRight:'1em'}}/>
    
                            <div style={{display:'flex',flexDirection:'column',marginTop:'-0.3em'}}>
                                <div className="TransactionName">
                                {t('Banktransfer')} 
                                </div>
                                {
                                    cookies.get('lang') === 'en' &&
                                <div className="TransactionDate">
                                    August 10
                                </div>
                                }
                                {
                                    cookies.get('lang') === 'jp' &&
                                <div className="TransactionDate">
                                    8月10日
                                </div>
                                }
                            </div>
    
                        </div>
                    
                         <div className="TransactionType">
                                    {t('Deposited')} 
                        </div>
                       
    
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'20%',alignContent:'flex-end',justifyContent:'flex-end'}}>
                        {
                                    cookies.get('lang') === 'en' &&
                                <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                                    $100.00
                                </div>
                        }
                        {
                                    cookies.get('lang') === 'jp' &&
                                <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                                    14680円
                                </div>
                        }
                           
    
                            <img src={paymentinfoicon} style={{width:'0.6em',height:'0.85em',marginLeft:'1.7em'}}/>
    
                        </div>
    
                    </div> */}

                    {/* <div className="TransactionListItem">
                        <div style={{display:'flex',flexDirection:'row',width:'30%'}}>
                            <img src={receivepaymenticon} style={{width:'2em',height:'2em',marginRight:'1em'}}/>
    
                            <div style={{display:'flex',flexDirection:'column',marginTop:'-0.3em'}}>
                                <div className="TransactionName">
                                {t('Royaltypayment')}
                                </div>
                                {
                                    cookies.get('lang') === 'en' &&
                                    <div className="TransactionDate">
                                    July 10
                                 </div>
                                }
                                {
                                    cookies.get('lang') === 'jp' &&
                                    <div className="TransactionDate">
                                    7月10日
                                 </div>
                                }
                                
                            </div>
    
                        </div>
    
                        <div className="TransactionType">
                        {t('Received')}
                        </div>
    
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'20%',alignContent:'flex-end',justifyContent:'flex-end'}}>
                        {
                                    cookies.get('lang') === 'en' &&
                                <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                                    $350.20
                                </div>
                        }
                        {
                                    cookies.get('lang') === 'jp' &&
                                <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                                    51381円
                                </div>
                        }
                           
    
                            <img src={paymentinfoicon} style={{width:'0.6em',height:'0.85em',marginLeft:'1.7em'}}/>
    
                        </div>
    
                    </div>
     */}
                    {/* <div className="TransactionListItem">
                        <div style={{display:'flex',flexDirection:'row',width:'30%'}}>
                            <img src={sendpaymenticon} style={{width:'2em',height:'2em',marginRight:'1em'}}/>
    
                            <div style={{display:'flex',flexDirection:'column',marginTop:'-0.3em'}}>
                                <div className="TransactionName">
                                {t('Merchantpayment')} Beats Market
                                </div>
                                {
                                    cookies.get('lang') === 'en' &&
                                    <div className="TransactionDate">
                                    July 2
                                 </div>
                                }
                                {
                                    cookies.get('lang') === 'jp' &&
                                    <div className="TransactionDate">
                                   7月2日
                                 </div>
                                }
                                
                            </div>
    
                        </div>
    
                        <div className="TransactionType">
                        {t('Sent')}
                        </div>
    
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'20%',alignContent:'flex-end',justifyContent:'flex-end'}}>
                        {
                                    cookies.get('lang') === 'en' &&
                                <div className="TransactionAmount" style={{color:"#FF6363"}}>
                                    -$49.90
                                 </div>
                        }
                        {
                                    cookies.get('lang') === 'jp' &&
                                <div className="TransactionAmount" style={{color:"#FF6363"}}>
                                    -7325円
                                 </div>
                        }
                            
    
                            <img src={paymentinfoicon} style={{width:'0.6em',height:'0.85em',marginLeft:'1.7em'}}/>
    
                        </div>
    
                    </div> */}

                    {/* <div className="TransactionListItem">
                        <div style={{display:'flex',flexDirection:'row',width:'30%'}}>
                            <img src={receivepaymenticon} style={{width:'2em',height:'2em',marginRight:'1em'}}/>
    
                            <div style={{display:'flex',flexDirection:'column',marginTop:'-0.3em'}}>
                                <div className="TransactionName">
                                {t('Royaltypayment')}
                                </div>
                                <div className="TransactionDate">
                                {
                                    cookies.get('lang') === 'en' &&
                                    <div className="TransactionDate">
                                     June 30
                                 </div>
                                }
                                {
                                    cookies.get('lang') === 'jp' &&
                                    <div className="TransactionDate">
                                   6月30日
                                 </div>
                                }
                                  
                                </div>
                            </div>
    
                        </div>
    
                        <div className="TransactionType">
                        {t('Received')}
                        </div>
    
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'20%',alignContent:'flex-end',justifyContent:'flex-end'}}>
                        {
                                    cookies.get('lang') === 'en' &&
                                <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                                    $32.90
                                </div>
                        }
                        {
                                    cookies.get('lang') === 'jp' &&
                                <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                                    4829円
                                </div>
                        }
                           
    
                            <img src={paymentinfoicon} style={{width:'0.6em',height:'0.85em',marginLeft:'1.7em'}}/>
    
                        </div>
    
                    </div> */}



                </div>
            }
        </div>

    );
}

export default Money;